"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "A longevidade profissional não é sobre o tempo de carreira, mas sobre a relevância contínua. O Hagaricast traz essa clareza para o executivo moderno.",
  name: "Ricardo Almeida",
  role: "Diretor de Operações, Global Corp",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/hagaricast_ricardo_almeida.png"
}, {
  id: 2,
  quote: "Estratégias reais para quem já chegou ao topo e deseja se manter lá com propósito. Um conteúdo indispensável para a liderança sênior brasileira.",
  name: "Beatriz Fontes",
  role: "VP de Talentos, Tech Solutions",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/hagaricast_beatriz_fontes.png"
}, {
  id: 3,
  quote: "O networking estratégico discutido nos episódios abriu portas que eu nem sabia que existiam. MasterPro+ é o novo padrão de consultoria executiva.",
  name: "Carlos Mendes",
  role: "Conselheiro Administrativo",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/hagaricast_carlos_mendes.png"
}, {
  id: 4,
  quote: "Insights profundos sobre transição de carreira e legado. A qualidade técnica e editorial do podcast reflete o nível de excelência da MasterPro+.",
  name: "Helena Souza",
  role: "CEO, Inovação & Futuro",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/hagaricast_helena_souza.png"
}];
export default function Testimonials() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const [isHovered, setIsHovered] = React.useState(false);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  React.useEffect(() => {
    if (!api || isHovered) return;
    const interval = setInterval(() => {
      if (api.canScrollNext()) {
        api.scrollNext();
      } else {
        api.scrollTo(0);
      }
    }, 4000);
    return () => clearInterval(interval);
  }, [api, isHovered]);
  return;
}